import React from 'react'
import { DropzoneOptions } from 'react-dropzone'
import { DropzoneProvider } from '../../../contexts/DropzoneContext'
import DropzoneContent from './DropzoneContent'

export type DropzoneProps = Omit<
	DropzoneOptions,
	'onDropAccepted'
> & {
	onDropAccepted?: (files: File[]) => void
	error?: boolean
	helperText?: string
	maxSize?: number
	maxFiles?: number
	renameParts?: string[]
}

const Dropzone = (props: DropzoneProps) => {
	return (
		<DropzoneProvider {...props}>
			<DropzoneContent />
		</DropzoneProvider>
	)
}

export default Dropzone
